import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { LeaderboardEntryDto } from "../../types/quiz-statistics";

export const useGetLeaderboard = () => {
  const axios = useAxios();

  return useQuery<LeaderboardEntryDto[]>({
    queryKey: ["challengesLeaderboard"],
    queryFn: async () => {
      const { data } = await axios.get("/api/challenges/GetLeaderboard");
      return data;
    },
    refetchInterval: 15_000,
  });
};
